
import DivBottom from '../userNotAuth/components/divBottom'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import ReactQuill from 'react-quill-new'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { NavbarNotAuth } from '../userNotAuth/components'

function AddArtistSuccess() {
    const redux = useSelector((state) => state.creaArtista.value)

    console.log('redux:', redux)
    const grid = {
        display: 'grid', gridTemplateColumns: '6rem 70% ', gap: '5px'
    }
    useEffect(() => { window.scrollTo(0, 0) }, [])
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <div className='container' style={{ marginBottom: '1rem', marginTop: '6rem' }}>
            <h4>PROFILO ARTISTA CREATO CON SUCCESSO!</h4>
            <p className='fs-6 mt-5'>
                Il tuo profilo di artista è stato creato ma prima di essere pubblicato dovrà essere approvato dal nostro staff.<br />
                Riceverai un'email di avvenuta pubblicazione del tuo profilo.
            </p>
            <hr />
            <div style={grid}>
                <div>Nome: </div> <div><b>{redux.nome}</b></div>
                <div>Cognome: </div> <div><b>{redux.cognome}</b></div>
            </div>
            {redux.gruppo !== '' &&
                <div style={grid}>
                    <div>Gruppo: </div> <div><b>{redux.gruppo}</b></div>
                </div>
            }
            <div style={grid}>
                <div>Genere: </div> <div><b>{redux.genere}</b></div>
                <div>N. comp: </div> <div><b>{redux.numero}</b></div>
                <div>Regione: </div> <div><b>{redux.regione}</b></div>
                <div>Città: </div> <div><b>{redux.città}</b></div>
                {redux.durata &&
                    <div style={grid}>
                        <div>Durata show: </div> <div><b>{redux.durata}</b></div>
                    </div>
                }
                {redux.cachet &&
                    <div style={grid}>
                        <div>Cachet: </div> <div><b>€ {redux.cachet}</b></div>
                    </div>
                }
            </div>
            <br />
            <div>DESCRIZIONE: </div>
            <ReactQuill className="textarea-quill"
                value={redux.descrizione}
                theme="snow"
                modules={{
                    toolbar: false
                }}
            />
            <br />
            {redux.telefono !== '' &&
                <div style={grid}>
                    <div>Telefono: </div> <div>{redux.telefono}</div>
                </div>
            }
            {redux.url !== '' &&
                <div style={grid}>
                    <div>URL sito web: </div> <div>{redux.url.substring(0, 30)}...</div>
                </div>
            }
            {redux.fb !== '' &&
                <div style={grid}>
                    <div>URL FB: </div> <div>{redux.fb.substring(0, 30)}...</div>
                </div>
            }
            {redux.youtube !== '' &&
                <div style={grid}>
                    <div>URL YouTube: </div> <div>{redux.youtube.substring(0, 30)}...</div>
                </div>
            }
            <div>Email: {redux.email}</div>
            {redux.foto &&
                <div className='mt-5'>
                    <h6>IMMAGINE CARICATA</h6>
                    <div className='gridAddEvento2 mt-3'>
                        <div>
                            <img src={`https://leuro-bucket.s3.amazonaws.com/${redux.foto}`} maxWwidth={220} height={180} />
                        </div>
                    </div>
                    <hr />
                </div>
            }
            {redux.video &&
                <div>
                    <p className='mt-3'>VIDEO CARICATO:</p>
                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${redux.video}`} width={220} height={180} controls />
                </div>
            }
        </div>
        <DivBottom />
    </>)
}
export default AddArtistSuccess
